export default "__VITE_ASSET__kNsyzpIa__"